import React from 'react'
import Tab, { TabItem } from '@/components/tab/tab'
import { getBEMCls } from '@/utils/classname'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import PurChaseContent, {
    GOODS_JOIN_STOCK,
    GOODS_SEARCH_STOCK,
    GOODS_UPDATE_STOCK,
    GOODS_REDUCE_STOCK,
    GOODS_RETURN_PURCHASE,
} from './router'

import { RouteComponentProps } from 'react-router'

import './stock-manage.scss'

const PurchaseManage = (props: RouteComponentProps) => {
    const tabList: TabItem[] = [
        {
            id: 0,
            name: '商品入库',
            route: GOODS_JOIN_STOCK,
        },
        {
            id: 1,
            name: '库存查询',
            route: GOODS_SEARCH_STOCK,
            perssion: 40,
        },
        {
            id: 2,
            name: '库存盘点',
            route: GOODS_UPDATE_STOCK,
            perssion: 43,
        },
        {
            id: 3,
            name: '商品报损',
            route: GOODS_REDUCE_STOCK,
            perssion: 44,
        },
        {
            id: 4,
            name: '采购退货记录',
            route: GOODS_RETURN_PURCHASE,
        },
    ]
    const getCls = (el?: string, m?: string) => getBEMCls('stock-manage', el, m)

    return (
        <Column className={getCls()}>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <Expaned className={getCls('content')}>
                <PurChaseContent {...props} />
            </Expaned>
        </Column>
    )
}

export default PurchaseManage
